import { ReactNode } from 'react';
import { useComputedWapiPlanSendGuard } from './useComputedWapiPlanSendGuard.hook';
import { WapiPlanSendGuardContext } from './useWapiPlanSendGuard.hook';

export default function WapiPlanSendGuardProvider(props: { children: ReactNode }) {
  const guard = useComputedWapiPlanSendGuard();
  return (
    <WapiPlanSendGuardContext.Provider value={guard}>
      {props.children}
    </WapiPlanSendGuardContext.Provider>
  );
}
